
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { faqs } from "@/core/data/faqs"; // dummy data

export default defineComponent({
  name: "soalan-lazim-page",
  components: {},
  setup() {
    const route = useRoute();

    const article = ref({});

    onMounted(() => {
      article.value =
        faqs[route.params.category.toString()][route.params.id.toString()];
    });

    return { article };
  },
});
